import { render } from "./ActionsButton.vue?vue&type=template&id=20c49e1a"
import script from "./ActionsButton.vue?vue&type=script&lang=js"
export * from "./ActionsButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__